export enum ColorClassName {
  Orange = "orange-range",
  Green = "green-range",
}
